<div
    (click)="click()"
    class="w-full max-w-[1140px]"
    [class.cursor-pointer]="clickable()"
    [attr.data-testid]="id()"
    [attr.data-styletarget]="id()"
>
    <h3
        [attr.data-testid]="id() + '-data-info'"
        [attr.data-styletarget]="id() + '-data-info'"
        [attr.data-uitype]="'title-h3'"
        class="mb-4 font-body-2-strong"
    >
        {{ dataInfoLt() }}
    </h3>
    @if((loadedLt()) && !errorLt()){

    <div
        class="h-2 flex"
        [attr.data-testid]="id() + '-gauge'"
        [attr.data-styletarget]="id() + '-gauge'"
    >
        <div
            class="h-full bg-dat-grey-300"
            [style.width.%]="(loads() / (loads() + trucks())) * 100"
            [attr.data-testid]="id() + '-bar-loads'"
            [attr.data-styletarget]="id() + '-bar-loads'"
            [attr.data-uitype]="'viz-bar'"
        ></div>
        <div
            class="bg-dat-grey-100 h-full"
            [attr.data-testid]="id() + '-bar-trucks'"
            [style.width.%]="(trucks() / (loads() + trucks())) * 100"
            [attr.data-styletarget]="id() + '-bar-trucks'"
            [attr.data-uitype]="'viz-bar'"
        ></div>
    </div>
    } @else {
    <div
        class="h-2 flex bg-dat-grey-300"
        [class.animate-pulse]="!errorLt()"
        [attr.data-testid]="id() + '-gauge-loading'"
        [attr.data-styletarget]="id() + '-gauge-loading'"
        [attr.data-uitype]="'loader'"
    ></div>
    }
    <label
        [attr.data-testid]="id() + '-label-loads'"
        [attr.data-styletarget]="id() + '-label-loads'"
        [attr.data-uitype]="'label'"
        class="font-caption-micro text-dat-grey-500 w-1/2 inline-block text-left"
    >
        {{ loadsLabel() }}
    </label>
    <label
        [attr.data-testid]="id() + '-label-trucks'"
        [attr.data-styletarget]="id() + '-label-trucks'"
        [attr.data-uitype]="'label'"
        class="font-caption-micro text-dat-grey-500 text-right inline-block w-1/2"
    >
        {{ trucksLabel() }}
    </label>
</div>
